"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Translate = (translations, key, option) => {
    const _a = option, { locale } = _a, res = __rest(_a, ["locale"]);
    let trans = translations[locale][key];
    Object.keys(res).forEach((o) => {
        trans = trans.replace(`{{${o}}}`, option[o]);
    });
    return trans;
};
exports.default = Translate;
